import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../utils/utils';
import { getLimits } from '../../../../crud/promocodes.crud';
import { ILimitsResponse } from '../../../../interfaces/promocodes';

export const useGetLimitsOperators: any = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [limits, setLimits] = useState<ILimitsResponse | null>(null);
  
  const fetch = useCallback(async () => {
    setLoading(true);
    getLimits()
      .then((res) => {
        setLimits(res.data.data)
        setSuccess(true);
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
        setSuccess(false);
      });
  }, []);
  return [fetch, limits, loading, success ];
};
